import Header from '../components/Header/Header';
import Footer from "../components/Footer/footer";
import Login_Window from "../components/Login/Login";

const Login = () => {
  return (
    <div style={{ paddingTop: '80px' }}>
      <Header />
      <Login_Window />
      <Footer />
    </div>
  );
};

export default Login;
